//#region Imports
import Swal from "sweetalert2/dist/sweetalert2.js";
//#endregion

//#region Private Functions

function getErrorString(data) {
  let msg = "<div><p>Unable to process your request due to the following error(s):</p>";
  if (data.errors) {
    for (let prop in data.errors) {
      msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop]
        .toString()
        .replace("$.", "")}</p>`;
    }
  } else if(data.response && data.response.data){
    for (let prop in data.response.data.errors) {
      msg += `<p>${data.response.data.errors[prop]}</p>`;
    }
  } else if (data.message) {
    msg += `<p>${data.message}</p>`;
  }else{
    msg += `<p>${data}</p>`;
  }
  return msg + "</div>";
}

//#endregion

//#region Export functions

export function customLoader(message = null) {
  const loader = Swal.fire({
    title: "Processing...",
    text: message,
    onOpen: () => {
      Swal.showLoading();
    },
    allowOutsideClick: () => !Swal.isLoading(),
    buttonsStyling: false,
    showConfirmButton: false,
  });

  return loader;
}

export function customSwal(
  message = null,
  title = null,
  icon = "success",
  customClass = { confirmButton: "btn btn-success" }
) {
  Swal.fire({
    title: title ?? "Success!",
    text: message ?? "Success",
    buttonsStyling: false,
    showConfirmButton: true,
    icon: icon,
    customClass: customClass,
  });
  return;
}

export function customError(data, title = null) {
  Swal.fire({
    title: title ?? "Error!",
    html: getErrorString(data) || "<p>Failed!</p>",
    icon: "error",
  });
  return;
}

export function customErrorMessage(data, title = null) {
  Swal.fire({
    title: title ?? "Error!",
    html:  "<p>"+data+"</p>",
    icon: "error",
  });
  return;
}

export function _calculateAge(dob) {
  // birthday is a date
  var ageDifMs = Date.now() - dob.getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function fnSortingDropdown(ddlObject, sortBy = "asc", key = "text") {
  if (ddlObject === undefined || ddlObject.length == 0) return ddlObject;
  return ddlObject.sort((a, b) => {
    const comparison = a[key].localeCompare(b[key]);
    return sortBy === "asc" ? comparison : -comparison;
  });
}

export function formatDate(date){
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function numericValidation(event){
  return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space';
}

export function allowOnlyNumbers(event) {
  if (event.type === 'wheel') {
    event.preventDefault();
  }else{
    const charCode = event.which ? event.which : event.keyCode;

    if (event.target.valueAsNumber < 0 ||
      (charCode < 48 || charCode > 57) &&  
      charCode !== 46 &&                   
      charCode !== 8                       
    ) {
      event.preventDefault();
        }
    
    if (charCode === 46 && event.target.value.includes('.')) {
      event.preventDefault();
    }
  }
}

//#endregion
